import React from "react";
import { Download, FileText } from "lucide-react";
import { downloadBlob } from "../../lib/downloadBlob";
import { latestDocs } from "../../lib/portalGroupTabs";
import { Chip } from "./PortalShell";
import Hint from "./Hint";

const MONTHS = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];

function day(iso) {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  return y ? `${d} ${MONTHS[m - 1]}` : "";
}

function ascii(s) {
  return String(s || "grupa").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^A-Za-z0-9]+/g, "_");
}

/**
 * Every document of the group in one place, in the order the course makes
 * them (06.10.2026): the name people use, the annex under it, the latest
 * version to download. Generating stays where the data is — the Prezență and
 * Portofolii tabs, or the team.
 */
export default function DocumentsTab({ presence, groupName }) {
  const rows = latestDocs(presence?.documents);
  return (
    <>
      <p className="flex items-start gap-1.5 text-sm text-[#6B7280]">
        <span>Ultima versiune a fiecărui document. Un document generat nu se mai schimbă: o corectură înseamnă o versiune nouă.</span>
        <Hint term="annexes" align="right" />
      </p>
      <ul className="mt-3 divide-y divide-[#E5E7EB] rounded-2xl border border-[#E5E7EB] bg-white" data-testid="portal-documents">
        {rows.map(({ def, doc, older }) => (
          <li key={def.kind + (doc?.scope || "")} className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3">
            <FileText size={17} className={`shrink-0 ${doc ? "text-[#965EA7]" : "text-[#D1D5DB]"}`} aria-hidden="true" />
            <div className="min-w-0 flex-1 basis-56">
              <p className={`text-sm font-semibold ${doc ? "text-[#373A45]" : "text-[#9CA3AF]"}`}>
                {def.name}{def.perDay && doc?.scope ? ` · ${day(doc.scope)}` : ""}
              </p>
              <p className="text-xs text-[#6B7280]">
                {def.annex}
                {doc
                  ? ` · versiunea ${doc.version}${older ? ` (încă ${older} ${older === 1 ? "mai veche" : "mai vechi"})` : ""} · generată pe ${day(doc.generated_at)}`
                  : ` · încă negenerată · ${def.where ? `se face din ${def.where}` : "o generează echipa"}`}
              </p>
            </div>
            {doc?.signed && <Chip tone="good">semnată</Chip>}
            {doc?.stale && <Chip tone="warn">nu mai e la zi</Chip>}
            {doc && (
              <span className="flex shrink-0 gap-3">
                {["pdf", "xlsx"].map((fmt) => (
                  <button key={fmt} type="button"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-[#965EA7] hover:underline"
                    onClick={() => downloadBlob(`/portal/documents/${doc.id}/${fmt}`,
                      `${def.annex.replace(/ /g, "_")}_${ascii(groupName)}${doc.scope ? `_${doc.scope}` : ""}_v${doc.version}.${fmt}`)}>
                    <Download size={12} /> {fmt === "pdf" ? "PDF" : "Excel"}
                  </button>
                ))}
              </span>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}
